export enum HeaderErrorEnum {
    OWN_ERROR = 'own_error',
}
